import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { PackageConfirmation } from "./component";
import { IStoreState } from "../../../../reducers/types";

export const mapStateToProps = (_: IStoreState) => {
  return {};
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesConfirmationConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackageConfirmation = withRouter(
  connector(PackageConfirmation)
);
